import React, { useEffect } from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';

export const BillingTin = () => {
  const MAX_LENGTH = 11;
  const MIN_LENGTH = 9;

  const isTinValid = (value) => {
    return (value.match(/\d/g) || []).length === 9;
  };

  useEffect(() => {}, []);

  return (
    <React.Fragment>
      <TextInput
        id="billingtin-textinput"
        model="searchRegistration.billingTin"
        subText="Enter the TIN you provide with claims submissions."
        aria-label="Type here to Enter a TIN "
        label="TIN"
        message="Billing TIN is invalid"
        maxLength={MAX_LENGTH}
        validators={{
          required: 'Billing TIN is required.',
          validate: {
            isValidTIN: (value) => {
              return (
                (value.length >= MIN_LENGTH &&
                  !value.includes('--') &&
                  !value.startsWith('-') &&
                  !value.endsWith('-') &&
                  isTinValid(value)) ||
                'Billing TIN is invalid.'
              );
            },
          },
        }}
        formatter={(value) => {
          return value.replace(
            /[!@#$%^&*)({}<>,.[\]+_`~=\\|';":/?A-Za-z]/g,
            ''
          );
        }}
        isClearable
        autoComplete="off"
        descriptorsDisplay="column"
      />
    </React.Fragment>
  );
};

BillingTin.propTypes = {};

BillingTin.defaultProps = {};
